<template>
    <div class="admin-welcome-page">
        <h3>Indicadores de Adopción</h3>
        <div class="dashboard">
            <iframe width="933" height="700" src="https://app.powerbi.com/view?r=eyJrIjoiNzBlNjQ5NTEtY2MwZi00MWJmLTg2NTgtZDUwNzViYjE4MjgzIiwidCI6Ijc5MWM1MTZiLWZhZGYtNDdkMS1hNjk1LTJhMmU4NjlmODg4ZCIsImMiOjR9" frameborder="0" allowFullScreen="true"></iframe>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>